import axios from "axios";
// const wait = timeout => new Promise(resolve => setTimeout(resolve, timeout));

const apiUrl = "/wp-json/sample-request/v1";
axios.defaults.baseURL = apiUrl;

const nonce = window.sampleRequestFormOpts?.nonce;

axios.defaults.headers = {
  ...(nonce ? { "EP-Nonce": nonce } : {})
};

// const postUserInfo = async form => {
//   const { data: session } = await axios.post("/user_info", form);

//   return session;
// };

// const postShippingInfo = async form => {
//   const { data } = await axios.post("/shipping_info", form);

//   return data;
// };

// const postOrder = async (sku, token) => {
//   return await axios.post("/order", { sku, token });
// };

// const postRate = async (rating, token) => {
//   return await axios.post("/rate", { rating, token });
// };

// const postReview = async token => {
//   return await axios.post("/review", { token });
// };

const loadProducts = async () => {
  const { data: products } = await axios.get("/products");

  return products;
};

const postFormData = async form => {
  return await axios.post("/form", form);
};

const validateForm = async (name, data) => {
  const { data: validation } = await axios.post("/validate-form", {
    name,
    data
  });

  return validation;
};

export default {
  loadProducts,
  postFormData,
  validateForm
  // postUserInfo,
  // postShippingInfo,
  // postOrder,
  // postRate,
  // postReview
};
